import { gql } from "@apollo/client";

export const GET_DEDUCTION_PRIORITIES_LOOKUP = gql`
  query DeductionPrioritiesLookup {
    masterDataDeductionPrioritiesLookup {
      count
      items {
        id
        priorityKey
        priorityName
        orderNumber
      }
    }
  }
`;
